export function checkListLength(htmlString: string): string | null {
  const normalizedString = htmlString.replace(/>\s+</g, '><').trim()

  if (!/^<ul>.*<\/ul>$/.test(normalizedString)) {
    return null
  }

  const liCount = (normalizedString.match(/<li/g) ?? []).length

  if (liCount <= 1) {
    return null
  }

  return htmlString
}
